export default class Analytics {
	init() {
		this._ga = window.GoogleAnalyticsObject;
	}

	broadcastEvent( name, event ) {
		var name = name || 'ncst.Event';
		var event = this.validateEvent( event );

		if ( this.isTagManager() ) {
			window.dataLayer.push( {
				event: name,
				ncst: {
					event: event,
				},
			} );
		} else if ( this.isUniversalAnalytics() ) {
			this._ga(
				'send',
				'event',
				event.category,
				event.action,
				event.label,
				event.value
			);
		}
	}

	ubSearch( term ) {
		if ( this.isTagManager() ) {
			window.dataLayer.push( {
				event: 'ncst.customSearch',
				ncst: {
					search: term,
				},
			} );
		} else if ( this.isUniversalAnalytics() ) {
			this._ga( 'send', 'pageview', '/ncst_search_ghost.php?q=' + term );
		}
	}

	isTagManager() {
		return typeof window.dataLayer !== 'undefined';
	}

	isUniversalAnalytics() {
		return (
			typeof this._ga === 'function' &&
			typeof this._ga.getAll === 'function'
		);
	}

	validateEvent( event ) {
		return {
			category: event.category || '',
			action: event.action || '',
			label: event.label || '',
			value: parseInt( event.value ) || 0,
		};
	}
}
